export default [{
  path: '/parcelamento/simplificado-previdenciario',
  component: {
    name: 'parcelamentoSimpPrevidenciarioBase',
    template: '<router-view />',
    meta: {
      resource: 'parcelamento_simp_previdenciario',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'parcelamento_simpl_previdenciario-view',
    component: () => import('@/app/parcelamentos/parcelamento-simplificado-previdenciario/ParcelamentoSimpPrevidenciario.vue'),
    meta: {
      tipo: 'simplificado_previdenciario',
      resource: 'parcelamento_simp_previdenciario',
      action: 'read',
      navActiveLink: 'parcelamento_simpl_previdenciario-view',
      pageTitle: 'Simplificado Previdenciário',
      breadcrumb: [
        {
          text: 'Simplificado Previdenciário',
          to: { name: 'parcelamento_simpl_previdenciario-view' },
          active: true,
        },
      ],
    },
  }],
},
]
